import React, { useState } from 'react';
import DrawingBoard from 'react-drawing-board';
import { Modal } from 'antd'; // dialog UI
import styles from './MobileHomeDraw.module.scss';

const MobileHomeDraw = () => {
  const [showDrawDialog, setShowDrawDialog] = useState(false);
  const [operations, setOperations] = useState([]);

  return (
    <>
      <Modal
        closable={false}
        okText
        cancelText="關閉"
        mask={false}
        className={styles.modal}
        open={showDrawDialog}
        onOk={() => {
          setShowDrawDialog(false);
        }}
        onCancel={() => {
          setShowDrawDialog(false);
        }}
      >
        <DrawingBoard
          // locale="zh-TW"
          toolbarPlacement="left"
          onSave={(data) => {
            // console.log('==canvas:', data.canvas);
            // console.log('==dataUrl:', data.dataUrl);
            const a = document.createElement('a');
            a.href = data.dataUrl;
            a.download = 'sketch.png';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
          }}
          operations={operations}
          onChange={(newOperation, afterOperation) => {
            console.log(`TODO: send ${newOperation}`);
            setOperations(afterOperation);
          }}
        />
      </Modal>
      {/* TODO:先移除小畫筆功能 */}
      {/* <div
        className={styles.mobileHeaderDraw}
        onClick={() => {
          setShowDrawDialog(true);
        }}
      >
        <img
          className={styles.drawImg}
          src="icon/ic_draw.svg"
          alt="Ic_account icon"
        />
      </div> */}
    </>
  );
};

export default MobileHomeDraw;
